{
  "generic": "Күтпеген қате орын алды",
  "network": "Желі қатесі. Байланысты тексеріңіз.",
  "notFound": "Бет табылмады",
  "forbidden": "Рұқсат жоқ",
  "tryAgain": "Қайта көру"
}
